import { Enumerated } from './Enumerated';

class FACEBOOK_STATUS extends Enumerated {
    static CONNECTED = 'connected'
    static UNKNOWN = 'unknown'
}

export { FACEBOOK_STATUS }
